export const hexToRgb = (hex: string) => {
    if (!/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
     console.log('Invalid hex color value');
    }
    hex = hex.substring(1);
    if (hex.length === 3) {
      hex = hex.split('').map(function(c) {
        return c + c;
      }).join('');
    }
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }
  